import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 222 218.4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="M219.45,218.4H2.55c-1.41,0-2.55-1.14-2.55-2.55V75.39C0,33.82,49.79,0,111,0s111,33.82,111,75.39v140.46c0,1.41-1.14,2.55-2.55,2.55ZM5.1,213.3h211.8V75.39c0-38.76-47.51-70.29-105.9-70.29S5.1,36.63,5.1,75.39v137.91Z" />
        <path d="M58.37,86.47h-20.82c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h20.82c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M184.45,86.47h-20.83c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h20.83c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M111,60.97c-8.34,0-15.12-6.79-15.12-15.12s6.79-15.13,15.12-15.13,15.12,6.79,15.12,15.13-6.78,15.12-15.12,15.12ZM111,35.82c-5.53,0-10.02,4.5-10.02,10.03s4.5,10.02,10.02,10.02,10.02-4.5,10.02-10.02-4.5-10.03-10.02-10.03Z" />
        <path d="M167.95,218.4H54.04c-1.41,0-2.55-1.14-2.55-2.55v-106.65c0-1.41,1.14-2.55,2.55-2.55h113.91c1.41,0,2.55,1.14,2.55,2.55v106.65c0,1.41-1.14,2.55-2.55,2.55ZM56.59,213.3h108.81v-101.55H56.59v101.55Z" />
        <path d="M146.35,134.26h-70.7c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h70.7c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M146.35,154.8h-70.7c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h70.7c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M146.35,175.35h-70.7c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h70.7c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M146.35,195.89h-70.7c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h70.7c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
      </g>
    </svg>
  )
}

export default Icon
